/**
 * Remembers the user's Glow intent per Spot in `localStorage` so switching tabs
 * (which unmounts the Radar page) doesn't drop it. The server is still the source
 * of truth — the Radar reconciles this with every heartbeat / poll response —
 * but seeding from here means the toggle shows the right state immediately and
 * the first heartbeat after a remount sends the correct value instead of a stale
 * `false`.
 */
const KEY = 'nm.glow';

type Map = Record<string, boolean>;

function readAll(): Map {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as Map) : {};
  } catch {
    return {};
  }
}

export function readGlowIntent(spotId: string | null): boolean {
  return spotId ? readAll()[spotId] === true : false;
}

export function writeGlowIntent(spotId: string | null, on: boolean): void {
  if (!spotId) return;
  try {
    const map = readAll();
    map[spotId] = on;
    localStorage.setItem(KEY, JSON.stringify(map));
  } catch {
    /* private mode — ignore */
  }
}
